<script setup lang="ts">
import { Button } from '@/components/ui/button'

defineProps<{
  selectedFont: string
}>()

defineEmits<{
  'update:model-value': [value: string]
}>()

const availableFonts = [
  { value: 'indopak', label: 'IndoPak' },
  { value: 'tajweed', label: 'Tajweed' },
]
</script>

<template>
  <div class="space-y-2">
    <div class="grid grid-cols-2 gap-2">
      <Button
        v-for="font in availableFonts"
        :key="font.value"
        @click="$emit('update:model-value', font.value)"
        :variant="selectedFont === font.value ? 'default' : 'outline'"
        size="sm"
        :class="[
          selectedFont === font.value
            ? ''
            : 'bg-sidebar-accent border-sidebar-border text-sidebar-foreground hover:bg-sidebar-accent/80',
          'flex-1'
        ]"
      >
        {{ font.label }}
      </Button>
    </div>
  </div>
</template>